import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../common/html/element'
import { selectCompanyInfo } from '../../common/header/companyInfo/store/slice'
import classes from './index.module.scss'

const FiscalYear = () => {
  const { fiscalYearEnd } = useSelector(selectCompanyInfo)

  if (!fiscalYearEnd) return null

  return (
    <Element
      className={classes.fiscalYear}
      style={{ color: '#3A414B', borderColor: '#9C9C9C' }}
    >
      <Translate
        value="companySummary.FISCAL_YEAR"
        style={{ fontWeight: 600, paddingRight: 0 }}
      />
      :&nbsp;{new Date(fiscalYearEnd).getFullYear()}
    </Element>
  )
}

export default FiscalYear
